import { createSelector } from 'reselect';
import { CONVERSATIONS_INTERACT } from 'conversations-internal-schema/constants/Scopes';
import { getScopes } from './getScopes';
export const hasConversationsInteract = createSelector([getScopes], scopes => scopes.includes(CONVERSATIONS_INTERACT));